module.exports = {
	"classes": [
		"b2b-saas-page",
		"header-dark"
	],
	"title": "B2B SaaS",
	"metas": {
		"description": "The Only Identity Platform Your Enterprise Customers Need"
	},
	"opengraph": {
		"og:title": "B2B SaaS",
		"og:description": "The Only Identity Platform Your Enterprise Customers Need",
		"og:url": "https://auth0.com/b2b-saas",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2b-saas/img/b2b-saas-twitter-card-b8bfd3a150.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2b-saas/img/b2b-saas-twitter-card-b8bfd3a150.png"
	},
	"twittercard": {
		"twitter:title": "B2B SaaS",
		"twitter:description": "The Only Identity Platform Your Enterprise Customers Need",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2b-saas/img/b2b-saas-twitter-card-b8bfd3a150.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2b-saas/metadata.json
// module id = 1365
// module chunks = 0